var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVendorLogo(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 369.6,
    height: 94.102,
    viewBox: "0 0 369.6 94.102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.861,
    y1: -0.047,
    x2: 0.195,
    y2: 0.788,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3dabe0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.963,
    y1: 0.076,
    x2: 0.245,
    y2: 0.973,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb1e5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6174f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-7932 -3041)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(7931.8 3040)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M369.8,17a6.9,6.9,0,1,1-6.9-6.9A6.914,6.914,0,0,1,369.8,17Zm-1.5-.1a5.442,5.442,0,0,0-5.4-5.4,5.4,5.4,0,1,0,5.4,5.4Zm-4.3.6,1.3,1.9q.3.6-.3.6h-.4a.864.864,0,0,1-.6-.3l-1.4-2.1h-.8v2a.472.472,0,0,1-.5.5H361a.472.472,0,0,1-.5-.5V14.5a.472.472,0,0,1,.5-.5h2.2c1.4,0,2.2.8,2.2,1.8A1.614,1.614,0,0,1,364,17.5Zm-.8-1c.6,0,1-.2,1-.7s-.4-.8-1-.8h-1.4v1.4h1.4Z",
    fill: "#171717"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M12.3,53.1a3.736,3.736,0,0,1,3.6-4.2l68.6-1.6a3.676,3.676,0,0,1,3.8,4L84.8,82.6A48.695,48.695,0,0,0,48.9,1,48.6,48.6,0,0,0,16.6,86Z",
    transform: "translate(7931.8 3040)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M46.2,94.9c-6.9-1.1-14.5-8.3-18.3-31.7-.2-1,0-1.6,1-1.7,1-.2,1.5.5,1.7,1.5,3.8,23.4,12.3,27,18.1,27,8,.1,13.2-7.2,16.4-25.1a1.909,1.909,0,0,1,2.2-1.5,1.858,1.858,0,0,1,1.5,2.2c-1.5,8.5-3.5,14.9-6,19.6-3.6,6.6-8.4,10-14.3,9.9a16.413,16.413,0,0,1-2.3-.2",
    transform: "translate(7931.8 3040)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M62.7,62.4a1.6,1.6,0,0,1-1.3-1.2,1.8,1.8,0,0,1,1-2.4,10.266,10.266,0,0,1,5.3-.7,7.619,7.619,0,0,1,4.6,2.1c.6.6,1.2,1.6.5,2.2-.3.3-1.3.2-2.1-.4a5.183,5.183,0,0,0-3.5-1,4.511,4.511,0,0,0-3.4,1.1.983.983,0,0,1-1.1.3",
    transform: "translate(7931.8 3040)",
    fill: "#eb1e5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M48.7,20.1c-7.9.9-15.6,3.6-20.2,21.8-.2.7-.1,1.1.9,1.2A1.546,1.546,0,0,0,31.2,42C36.6,25,43.7,23.8,51,23.6c8.1-.2,13,4.9,15,17.7.1.7,1.1,1.2,2.1,1s1.8-.9,1.7-1.6c-1-6.1-2.6-10.7-4.8-14-3.2-4.7-7.9-7-13.9-6.8-.8.1-1.5.1-2.4.2",
    transform: "translate(7931.8 3040)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M134.2,66a1.562,1.562,0,0,1-1.7,1.2h-9.1a1.708,1.708,0,0,1-1.7-1.2L109.1,28.1c-.4-1.1.1-1.8,1.2-1.8h5.6a1.708,1.708,0,0,1,1.7,1.2l10,30h.9l9.9-30a1.562,1.562,0,0,1,1.7-1.2h5.6c1.1,0,1.6.7,1.2,1.8Z",
    transform: "translate(7931.8 3040)",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M187.8,47.3a1.477,1.477,0,0,1-1.6,1.4H158.8c.4,8.3,5.2,11.7,11.3,11.7a8.537,8.537,0,0,0,8-4.3,1.92,1.92,0,0,1,1.8-1.1h5.4c1.1,0,1.7.7,1.2,1.8a17.967,17.967,0,0,1-17.2,11.6c-11.3,0-19.4-8.5-19.4-21.4S158,25,170,25c12.6,0,18.5,9.9,17.8,22.3m-28.5-5.5h19.4c-.1-4.6-3.3-8.8-9.4-8.8-6.4-.1-9,4.3-10,8.8",
    transform: "translate(7931.8 3040)",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M229.2,40.8V65.6a1.326,1.326,0,0,1-1.5,1.5h-6.4a1.326,1.326,0,0,1-1.5-1.5V43.1c0-6.3-2.8-9.5-7.3-9.5-5.6,0-9.8,4.5-9.2,14.1l.2,18a1.326,1.326,0,0,1-1.5,1.5h-6.3a1.326,1.326,0,0,1-1.5-1.5l.3-37.9a1.326,1.326,0,0,1,1.5-1.5h5.7a1.326,1.326,0,0,1,1.5,1.5l.1,4h.6c3-4.6,6.9-6.8,11.9-6.8,7.8.1,13.4,5.9,13.4,15.8",
    transform: "translate(7931.8 3040)",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M266.2,67.2a1.326,1.326,0,0,1-1.5-1.5V61.8h-.5c-2.6,4.6-7.2,6.6-12.1,6.6-9.9,0-16.8-8.9-16.8-21.2,0-13.3,7.8-22.2,19.4-22.2a13.324,13.324,0,0,1,9.9,3.9h.4l.1-17.5a1.326,1.326,0,0,1,1.5-1.5h5.7a1.326,1.326,0,0,1,1.5,1.5l.3,54.2a1.326,1.326,0,0,1-1.5,1.5h-6.4Zm-.8-20.9c.2-9.2-4.9-13.4-11-13.4-6.7,0-10.3,5.1-10.3,13.6,0,9.1,4.3,13.9,10.4,13.9,6.2,0,11.1-5,10.9-14.1",
    transform: "translate(7931.8 3040)",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M320.1,46.3c0,12.8-8.8,22.2-20.3,22.2-11.2,0-19.6-8.9-19.6-21.5,0-12.9,8.7-21.9,20.3-21.9,11.2,0,19.6,8.5,19.6,21.2m-30.9-.2c0,8.8,5.2,14.3,11.6,14.3,6,0,10.4-5.1,10.4-13.2,0-8.9-5.1-14.3-11.6-14.3-6.1,0-10.4,5-10.4,13.2",
    transform: "translate(7931.8 3040)",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M348.6,33.1a1.326,1.326,0,0,1-1.5,1.5c-7,.2-12,2.4-11.6,12.9l.2,18.2a1.326,1.326,0,0,1-1.5,1.5h-6.3a1.326,1.326,0,0,1-1.5-1.5l.3-37.9a1.326,1.326,0,0,1,1.5-1.5h5.7a1.326,1.326,0,0,1,1.5,1.5l.1,3.9h.6a16.255,16.255,0,0,1,11-6.6c1.1-.1,1.6.5,1.6,1.5v6.5h-.1Z",
    transform: "translate(7931.8 3040)",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M227,81.1c0,.2-.1.2-.2.2a3.146,3.146,0,0,0-3.3,2.9V90c0,.2-.1.2-.2.2h-.9c-.2,0-.2-.1-.2-.2V80.3c0-.2.1-.2.2-.2h.8c.2,0,.2.1.2.2v1.5h.1a4.122,4.122,0,0,1,3.2-2c.2,0,.2.1.2.2l.1,1.1Z",
    transform: "translate(7931.8 3040)",
    fill: "#3dabe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M237.4,85c0,.2-.1.2-.2.2h-7.5c0,2.4,1.2,4.1,3.4,4.1a2.823,2.823,0,0,0,2.7-1.6c.1-.1.2-.2.3-.2h.8c.2,0,.3.1.2.3a4.26,4.26,0,0,1-4.1,2.6c-2.8,0-4.6-2.1-4.6-5.2,0-3.2,2-5.3,4.7-5.3,2.8.1,4.3,2.3,4.3,5.1m-7.7-.8H236a3.052,3.052,0,0,0-3.1-3.1,3.34,3.34,0,0,0-3.2,3.1",
    transform: "translate(7931.8 3040)",
    fill: "#3dabe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M244.4,81c0,.2-.1.2-.2.2h-2.1V90c0,.2-.1.2-.2.2H241c-.2,0-.2-.1-.2-.2V81.2h-1.7c-.2,0-.2-.1-.2-.2v-.6c0-.2.1-.2.2-.2h1.7V76.4c0-.2.1-.2.2-.2h.8c.2,0,.2.1.2.2v3.8h2.1c.2,0,.2.1.2.2l.1.6Z",
    transform: "translate(7931.8 3040)",
    fill: "#3dabe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M247.9,81.7a4.164,4.164,0,0,1,3.3-1.7c1.9,0,3.1,1.2,3.1,3.5v6.6c0,.2-.1.2-.2.2h-.9c-.2,0-.2-.1-.2-.2V83.8c0-1.7-.8-2.6-2.2-2.6a3.166,3.166,0,0,0-3,2.8v6.1c0,.2-.1.2-.2.2h-.9c-.2,0-.2-.1-.2-.2V76.2c0-.2.1-.2.2-.2h.8c.2,0,.2.1.2.2v5.5Z",
    transform: "translate(7931.8 3040)",
    fill: "#3dabe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M259,90.1c0,.2-.1.2-.2.2h-.9c-.2,0-.2-.1-.2-.2V80.4c0-.2.1-.2.2-.2h.8c.2,0,.2.1.2.2Zm-.1-12.6c0,.2-.1.2-.2.2h-.8c-.2,0-.2-.1-.2-.2V76.2c0-.2.1-.2.2-.2h.8c.2,0,.2.1.2.2Z",
    transform: "translate(7931.8 3040)",
    fill: "#3dabe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M270.2,83.5v6.6c0,.2-.1.2-.2.2h-.9c-.2,0-.2-.1-.2-.2V83.8c0-1.8-.9-2.6-2.2-2.6-1.5,0-2.6,1-3.1,2.8v6.1c0,.2-.1.2-.2.2h-.9c-.2,0-.2-.1-.2-.2V80.4c0-.2.1-.2.2-.2h.8c.2,0,.2.1.2.2v1.4h.1A4.3,4.3,0,0,1,267,80c1.9-.1,3.2,1.2,3.2,3.5",
    transform: "translate(7931.8 3040)",
    fill: "#3dabe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M274.6,86.4V90c0,.2-.1.2-.2.2h-.9c-.2,0-.2-.1-.2-.2l.1-13.9c0-.2.1-.2.2-.2h.8c.2,0,.2.1.2.2v8.8l5.1-4.8a.367.367,0,0,1,.3-.1h.9c.2,0,.3.1.1.3l-4,3.8,4.3,5.8c.1.2.1.3-.1.3h-1a.367.367,0,0,1-.3-.1l-3.7-5.2Z",
    transform: "translate(7931.8 3040)",
    fill: "#3dabe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M295.2,82.4c.1.2,0,.3-.2.3h-.8c-.1,0-.2-.1-.3-.2a2.6,2.6,0,0,0-2.6-1.4c-1.3,0-2.2.6-2.2,1.6,0,.9.9,1.3,2.3,1.7l.8.2c2.2.7,3.2,1.5,3.2,2.9,0,1.8-1.5,3-3.8,3a4.157,4.157,0,0,1-4.2-2.7c-.1-.2,0-.3.2-.3h.9c.1,0,.2.1.3.2a2.871,2.871,0,0,0,2.9,1.6c1.3,0,2.4-.5,2.4-1.7,0-1-.8-1.5-2.5-2l-.8-.2c-1.8-.5-3-1.2-3-2.7,0-1.7,1.5-2.8,3.6-2.8a3.691,3.691,0,0,1,3.8,2.5",
    transform: "translate(7931.8 3040)",
    fill: "#3dabe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M306.3,85c0,.2-.1.2-.2.2h-7.5c0,2.4,1.2,4.1,3.4,4.1a2.823,2.823,0,0,0,2.7-1.6c.1-.1.2-.2.3-.2h.8c.2,0,.3.1.2.3a4.26,4.26,0,0,1-4.1,2.6c-2.8,0-4.6-2.1-4.6-5.2,0-3.2,2-5.3,4.7-5.3,2.8.1,4.3,2.3,4.3,5.1m-7.6-.8H305a3.052,3.052,0,0,0-3.1-3.1,3.2,3.2,0,0,0-3.2,3.1",
    transform: "translate(7931.8 3040)",
    fill: "#3dabe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M310.6,90.1c0,.2-.1.2-.2.2h-.9c-.2,0-.2-.1-.2-.2l.1-13.9c0-.2.1-.2.2-.2h.8c.2,0,.2.1.2.2Z",
    transform: "translate(7931.8 3040)",
    fill: "#3dabe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M316,90.1c0,.2-.1.2-.2.2h-.9c-.2,0-.2-.1-.2-.2l.1-13.9c0-.2.1-.2.2-.2h.8c.2,0,.2.1.2.2Z",
    transform: "translate(7931.8 3040)",
    fill: "#3dabe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M321,90.1c0,.2-.1.2-.2.2h-.9c-.2,0-.2-.1-.2-.2V80.4c0-.2.1-.2.2-.2h.8c.2,0,.2.1.2.2Zm0-12.6c0,.2-.1.2-.2.2H320c-.2,0-.2-.1-.2-.2V76.2c0-.2.1-.2.2-.2h.8c.2,0,.2.1.2.2Z",
    transform: "translate(7931.8 3040)",
    fill: "#3dabe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M332.3,83.5v6.6c0,.2-.1.2-.2.2h-.9c-.2,0-.2-.1-.2-.2V83.8c0-1.8-.9-2.6-2.2-2.6-1.5,0-2.6,1-3.1,2.8v6.1c0,.2-.1.2-.2.2h-.9c-.2,0-.2-.1-.2-.2V80.4c0-.2.1-.2.2-.2h.8c.2,0,.2.1.2.2v1.4h.1a4.3,4.3,0,0,1,3.4-1.8c1.9-.1,3.2,1.2,3.2,3.5",
    transform: "translate(7931.8 3040)",
    fill: "#3dabe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M342.5,81.7h.1V80.4c0-.2.1-.2.2-.2h.8c.2,0,.2.1.2.2l.1,8.9c0,3.6-1.7,5.5-4.5,5.5a4.126,4.126,0,0,1-4.1-2.6c-.1-.2,0-.3.2-.3h.8c.1,0,.2.1.3.2a2.971,2.971,0,0,0,2.8,1.5c2,0,3.2-1.2,3.1-4v-.7h-.1a3.95,3.95,0,0,1-3.1,1.4c-2.7,0-4.6-2-4.6-5.2,0-3,1.7-5.2,4.3-5.2a3.981,3.981,0,0,1,3.5,1.8M336,85.2c0,2.4,1.3,3.9,3.3,3.9a3.215,3.215,0,0,0,3.3-2.7V84a3.329,3.329,0,0,0-3.3-3c-1.9.1-3.3,1.7-3.3,4.2",
    transform: "translate(7931.8 3040)",
    fill: "#3dabe0"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorLogo);
export default __webpack_public_path__ + "static/media/vendor-logo.ac006fea563d35542cb78628eb1e33ec.svg";
export { ForwardRef as ReactComponent };